import { openedSessionTabAtom, openedSessionTabEnum } from '@/atoms/sideNavAtoms';
import SessionBarMobileButton from '@/components/layout/Navigation/sessions/header/new-session-mobile-button';
import MobileSessionBarPanelCloseButton from '@/components/layout/Navigation/sessions/header/panel-close-button';
import { SessionReviewComboBox } from '@/components/layout/Navigation/sessions/header/review-combobox';
import SessionBarSearchBar from '@/components/layout/Navigation/sessions/header/search-bar';
import SessionBarTitle from '@/components/layout/Navigation/sessions/header/title';
import { SessionsToolbar } from '@/components/layout/Navigation/sessions/header/toolbar';
import SessionBarStatusTextV2 from '@/features/upcomingSessionTab/components/status-text-v2';
import UpcomingTabHeaderButtonsV2 from '@/features/upcomingSessionTab/components/upcoming-tab-header-buttons-v2';
import { useShowSessionReview } from '@/hooks/useShowSessionReview';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

function SessionsHeaderV2() {
  const showSessionReview = useShowSessionReview();

  const openedSessionTab = useAtomValue(openedSessionTabAtom);

  const isMobile = useIsMobile();

  return (
    <>
      <div className="flex h-6 items-center justify-between">
        {isMobile && <SessionBarTitle />}

        {showSessionReview && <SessionReviewComboBox />}

        {openedSessionTab === openedSessionTabEnum.PAST && <SessionsToolbar />}

        <UpcomingTabHeaderButtonsV2 />

        <MobileSessionBarPanelCloseButton />
      </div>

      <SessionBarStatusTextV2 />

      <SessionBarSearchBar />

      {/* new session button on mobile */}
      <SessionBarMobileButton />
    </>
  );
}

export default memo(SessionsHeaderV2);
